/**
 * Title helpers. Outlook's normalizedSubject already strips Re:/Fw:, but a hand-edited
 * title can re-introduce them, and subjects longer than 255 need a visible truncation.
 */

const MAX_TITLE = 255;
const ELLIPSIS = '...';

const LEADING_REPLY = /^(?:(?:re|fw|fwd)\s*:\s*)+/i;

export function stripReplyPrefixes(subject: string): string {
  return subject.replace(LEADING_REPLY, '').trim();
}

export function truncateTitle(title: string): string {
  const trimmed = title.trim();
  if (trimmed.length <= MAX_TITLE) return trimmed;
  return trimmed.slice(0, MAX_TITLE - ELLIPSIS.length) + ELLIPSIS;
}

export function prepareTitle(subject: string): string {
  return truncateTitle(stripReplyPrefixes(subject));
}

export const TITLE_MAX = MAX_TITLE;
